export const PAYMENT_METHOD_OPTIONS = [
  { value: "PIX", label: "PIX" },
  { value: "TED", label: "TED" },
  { value: "BOLETO", label: "Boleto" },
  { value: "CHEQUE", label: "Cheque" },
] as const

export const HAS_COPYRIGHT_OPTIONS = [
  { value: "false", label: "Não" },
  { value: "true", label: "Sim" },
] as const

export const COPYRIGHT_TYPE_OPTIONS = [
  { value: "PATRIMONIAL", label: "Patrimonial" },
  { value: "MORAL", label: "Moral" },
  { value: "BOTH", label: "Ambos" },
] as const
